<template>
    <div id="app">
        <router-view />
        <error-banner></error-banner>
        <div v-if="isLoading" class="is-loading-mask"></div>
    </div>
</template>

<script lang="js">
import Vue from 'vue';
import ErrorBanner from "@/components/common/ErrorBanner";
import { mapState } from "vuex";

export default Vue.extend({
   components: {
       ErrorBanner,
   },
  computed: {
       ...mapState(['isLoading']),
  },
});
</script>

<style src="nprogress/nprogress.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@import '~bootstrap';
@import '~bootstrap-vue';
@import 'assets/styles/vue_multiselect.scss';
@import 'assets/styles/ims-tooltip-theme.scss';

html,
body {
    height: 100%;
    margin: 0;
    background-image: $background-gradient;
    background-attachment: fixed;
    scroll-behavior: smooth;
    line-height: 1.25;
    font-family: Roboto, Helvetica, Arial, sans-serif;
    color: $blue-midnight;
}
h1,
p {
    margin: 0;
}
input {
    box-sizing: border-box;
}
a {
    text-decoration: none;
    color: $blue-royal;
}
label {
    margin: 0;
}
#app {
    font-family: Roboto, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    .is-loading-mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(to bottom, $grey-nickel, #edeeee 28%);
    }
    a {
        text-decoration: none;
        color: $blue-royal;
    }
    span.link {
        color: $blue-royal;
        cursor: pointer;
    }
    svg {
        vertical-align: initial;
    }
}

svg {
    fill: currentColor;
}

#nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}
</style>
